var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_43_3",
    "data-name": "Component 43 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.179,
    height: 20.861,
    viewBox: "0 0 37.179 20.861",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M688.459,813.534a10.431,10.431,0,1,1,10.5-10.284A10.419,10.419,0,0,1,688.459,813.534Z",
    transform: "translate(-678.043 -792.673)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M712.062,803.139a15.594,15.594,0,0,1-1.538,6.771,8.464,8.464,0,0,1-1.708,2.259,3.119,3.119,0,0,1-4.474-.054,9.241,9.241,0,0,1-2.616-5.075,16.073,16.073,0,0,1,.948-10.526,8.472,8.472,0,0,1,1.712-2.361,3.1,3.1,0,0,1,4.407-.1,9.031,9.031,0,0,1,2.777,5.342C711.825,800.624,711.9,801.89,712.062,803.139Z",
    transform: "translate(-679.535 -792.705)",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M717.492,803.235c-.359,2.453-.677,4.864-1.087,7.261-.111.646-.279,1.615-1.105,1.53-.409-.042-.891-.933-1.055-1.521a26.548,26.548,0,0,1-.778-9.261,48.867,48.867,0,0,1,.774-5.311c.12-.637.273-1.62,1.11-1.529.408.044.932.94,1.038,1.518C716.83,798.339,717.134,800.782,717.492,803.235Z",
    transform: "translate(-680.313 -792.784)",
    fill: "#989898"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedIcon);
export default __webpack_public_path__ + "static/media/med-icon.81c0b226176bea23916969d7881bdf23.svg";
export { ForwardRef as ReactComponent };